module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/banner_sola_plan-b1d0685d1b048d6fc79f54a69500375c.jpg";